import React from 'react'
import type {CardProps} from './types'

const BaseCard: React.FC<CardProps> = ({
  title,
  titleAddon,
  children,
  headerRight,
  headerClassName = '',
  headerRef,
  className = '',
  disableDefaultGap = false,
  contentClassName,
}) => {
  const wrapperGapClass = disableDefaultGap ? '' : 'gap-6'
  const resolvedContentClassName = contentClassName ?? (disableDefaultGap ? className : className || 'gap-6')

  return (
    <div
      className={`flex grow flex-col rounded-lg p-6 shadow-lg ${wrapperGapClass} ${className}`}
      style={{backgroundColor: 'var(--color-background-layer-01)'}}
    >
      <div
        ref={headerRef}
        className={`flex items-center justify-between bg-[var(--color-background-layer-01)] ${headerClassName}`}
      >
        <div className="flex items-center gap-2">
          <h5
            className="text-title-large overflow-hidden leading-7 text-ellipsis select-none"
            style={{color: 'var(--color-text-primary)'}}
            data-testid="card-header"
          >
            {title}
          </h5>
          {titleAddon}
        </div>
        {headerRight && (
          <div className="ml-auto flex flex-shrink-0 items-center" data-testid="card-header-right">
            {headerRight}
          </div>
        )}
      </div>
      <div className={`flex w-full flex-col ${resolvedContentClassName}`} data-testid="card-content">
        {React.Children.map(children, child => (
          <div className="min-w-0 flex-1">{child}</div>
        ))}
      </div>
    </div>
  )
}

export default BaseCard
